import { TextLayer, GeoJsonLayer } from '@deck.gl/layers'
import { CompositeLayer } from '@deck.gl/core'

const defaultProps = {
  // Inherit all of GeoJsonLayer's props
  ...GeoJsonLayer.defaultProps,
  // Label for each feature
  getLabel: { type: 'accessor', value: d => String(d.properties._cdb_feature_count) },
  // Label size for each feature
  getLabelSize: { type: 'accessor', value: 12 },
  // Label color for each feature
  getLabelColor: { type: 'accessor', value: [255, 255, 255, 255] },
  // position of each label
  getLabelPosition: { type: 'accesor', value: d => d.geometry.coordinates },
  // Label always facing the camera
  billboard: true,
  // Label size units
  labelSizeUnits: 'pixels',
  // Text size multiplier
  labelSizeScale: 2,
  // A unitless number that will be multiplied with the current font-size to set the line height.
  labelLineHeight: 14 / 12,
  // Label background color
  labelBackground: { type: 'color', value: null, optional: true },
  // css font family
  fontFamily: 'Monaco, monospace',
  // css font weight
  fontWeight: 400,
  // whether to disable clipping for the geojson layer
  disableClipping: false,
  // prop to override the use of GeojsonLayer
  geomLayer: GeoJsonLayer
}

class LabeledGeoJsonLayer extends CompositeLayer {
  renderLayers () {
    const {
      getLabel,
      getLabelSize,
      getLabelColor,
      getLabelPosition,
      labelSizeUnits,
      labelSizeScale,
      labelLineHeight,
      labelBackground,
      billboard,
      fontFamily,
      fontWeight,
      geomLayer: GeomLayer
    } = this.props
    return [
      new GeomLayer(
        this.props,
        this.getSubLayerProps({ id: 'geojson' }),
        { data: this.props.data }
      ),
      new TextLayer(
        this.getSubLayerProps({ id: 'text' }),
        {
          data: this.props.data,
          billboard,
          fontFamily,
          fontWeight,
          sizeUnits: labelSizeUnits,
          sizeScale: labelSizeScale,
          lineHeight: labelLineHeight,
          backgroundColor: labelBackground,
          getPosition: getLabelPosition,
          getText: this.getSubLayerAccessor(getLabel),
          getSize: this.getSubLayerAccessor(getLabelSize),
          getColor: this.getSubLayerAccessor(getLabelColor),
          getPixelOffset: [0, 1]
        }
      )
    ]
  }
}

LabeledGeoJsonLayer.layerName = 'LabeledGeoJsonLayer'
LabeledGeoJsonLayer.defaultProps = defaultProps

export default LabeledGeoJsonLayer
